import { render, staticRenderFns } from "./ClientTransactionsSearch.vue?vue&type=template&id=134a9f80&scoped=true&"
import script from "./ClientTransactionsSearch.vue?vue&type=script&lang=js&"
export * from "./ClientTransactionsSearch.vue?vue&type=script&lang=js&"
import style0 from "./ClientTransactionsSearch.vue?vue&type=style&index=0&id=134a9f80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "134a9f80",
  null
  
)

export default component.exports